import ModalCardHarmony from '../components/DetailModal/HarmonyDetailModal';
import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import { dataHarmony } from '@orientaction/utils';
import { FC, useState } from 'react';
import HarmonyResultChart from '../components/HarmonyResultChart';
import ResultDetailCard from '../components/ResultDetailCard';
import {
  DetailsSection,
  SummaryCard,
  SummaryGrid,
  SummarySideCards,
} from '../components/SummarySection';
import { useMajorResultStyles } from '../MajorResult.styles';
import { MajorTestContentProps } from '../types';
import { useHarmonyContentStyles } from './HarmonyContent.styles';
import { getHarmonyRankStyle, harmonyImages } from './harmonyPresentation';

const HarmonyContent: FC<MajorTestContentProps> = ({ myResult }) => {
  const classes = useMajorResultStyles();
  const local = useHarmonyContentStyles();
  const [selectedHarmony, setSelectedHarmony] = useState<any>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const harmonyItems = dataHarmony(myResult).map((harmony, index) => ({
    ...harmony,
    color: getHarmonyRankStyle(index).backgroundColor,
    labelColor: getHarmonyRankStyle(index).color,
    imageSrc: harmonyImages[harmony.img],
  }));

  const openModal = (harmony: any) => {
    setSelectedHarmony(harmony);
    setModalOpen(true);
  };

  return (
    <>
      <SummaryGrid>
        <SummaryCard title="SYNTHÈSE DE VOS RÉSULTATS">
          <div className={classes.harmonyChart}>
            {myResult && <HarmonyResultChart result={myResult} />}
          </div>
        </SummaryCard>

        <SummarySideCards>
          <SummaryCard title="DÉCOUVREZ VOS 16 SOFT SKILLS">
            <div className={local.introduction}>
              <p>
                Les soft skills ou compétences douces sont des compétences que l’on acquiert par
                l’expérience, par opposition aux hard skills qui s’acquièrent dans le cadre d’une
                formation ou de ses études.
              </p>
              <p>
                <strong>
                  Les soft skills sont aujourd’hui la clef de la réussite professionnelle.
                </strong>
              </p>
              <p>
                Les développer vous aidera à devenir un(e) collaborateur (trice) reconnu(e) et
                apprécié(e) dans son organisation. Dans votre sphère de vie personnelle, cela fera
                de vous une personne accomplie et respectée pour ses qualités humaines. Le fait de
                les tester est une première étape avant de progresser. À vous de jouer !
              </p>
            </div>
          </SummaryCard>
          <SummaryCard title="VOS 3 SOFT SKILLS LES + DÉVELOPPÉES">
            <div className={local.topSkills}>
              {harmonyItems.slice(0, 3).map(harmony => (
                <button
                  key={harmony.key}
                  type="button"
                  className={local.skillButton}
                  style={{ backgroundColor: harmony.color, color: harmony.labelColor }}
                  onClick={() => openModal(harmony)}
                >
                  {harmony.key}
                </button>
              ))}
            </div>
            <p className={local.hint}>Cliquez sur une soft skills pour en savoir + !</p>
          </SummaryCard>
        </SummarySideCards>
      </SummaryGrid>

      <DetailsSection title="DÉCOUVREZ VOS SOFT SKILLS">
        {harmonyItems.map((harmony: any) => (
          <ResultDetailCard
            key={harmony.key}
            label={harmony.key}
            color={harmony.color}
            labelColor={harmony.labelColor}
            imageSrc={harmony.imageSrc}
            imageAlt={harmony.key}
            onLearnMore={() => openModal(harmony)}
            imageOverlay={
              <div className={`${classes.scoreBadge} ${local.score}`}>
                <CircularProgressCustom
                  value={harmony.value}
                  color={harmony.color}
                  size={98}
                  fontSize={18}
                  fontSizeFloat={12}
                />
              </div>
            }
          />
        ))}
      </DetailsSection>

      {selectedHarmony && (
        <ModalCardHarmony
          open={modalOpen}
          onCancel={() => {
            setModalOpen(false);
            setSelectedHarmony(null);
          }}
          color={selectedHarmony.color}
          img={selectedHarmony.imageSrc}
          label={selectedHarmony.key}
          colorSecondary={selectedHarmony.colorSecondary}
          opacity={!!selectedHarmony.opacity}
          value={selectedHarmony.value}
          text1={selectedHarmony.text1}
          listeAccordeon={selectedHarmony.listeAccordeon}
          listEmploi1={selectedHarmony.listEmploi1}
          text2={selectedHarmony.text2}
          title={selectedHarmony.title}
          citation={selectedHarmony.citation}
          titleAd={selectedHarmony.titleAd}
          descriptionAd={selectedHarmony.descriptionAd}
          imgAd={selectedHarmony.imgAd}
        />
      )}
    </>
  );
};

export default HarmonyContent;
